import { CustomTableParams } from '@/models/custom-table-params.model';
import { UserService } from '@/services';
import { CustomTableMeta } from '@/models/custom-table-meta.model';
import { CustomTableColumn } from '@/models/custom-table-column.model';
import CustomTable from '@/components/shared/custom-table/custom-table/custom-table.component';
import { CustomUser } from '@/models/custom-user.model';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Notification = namespace('notification');

@Component({
    components: {
        CustomTable,
    },
})
export default class UserListView extends Vue {
    @Notification.Action('addError') private addError: any;

    public tableColumns: CustomTableColumn[] = [
        { title: 'attributes.id.label', accessor: 'id' },
        { title: 'attributes.firstName.label', accessor: 'first_name' },
        { title: 'attributes.lastName.label', accessor: 'last_name' },
        { title: 'attributes.email.label', accessor: 'email' },
        { title: 'attributes.createdAt.label', accessor: 'created_at|datetime' },
    ];

    public inFlight: boolean = false;
    public users: CustomUser[] = [];

    public tableMeta: CustomTableMeta = null;
    public tableParams: CustomTableParams = {
        size: 15,
        page: 1,
    };

    public mounted() {
        this.tableParams.size = parseInt(this.$route.query.size as string, 10) || 15;
        this.tableParams.page = parseInt(this.$route.query.page as string, 10) || 1;

        this.getData(this.tableParams);
    }

    private async getData(tableParams: CustomTableParams) {
        this.inFlight = true;
        try {
            const response = await UserService.list(tableParams);
            this.tableMeta = response.data.meta;
            this.users = response.data.content;
            this.inFlight = false;
        } catch (error) {
            this.addError(error.localized);
            this.inFlight = false;
        }
    }

    private updateUrl(newTableParams: CustomTableParams) {
        this.$router.push({
            query: {
                page: `${newTableParams.page}`,
                size: `${newTableParams.size}`,
            },
        });
    }

    public redirectUser(id: number) {
        this.$router.push(`users/${id}`);
    }

    public handleTableParamsChanged(newTableParams: CustomTableParams) {
        this.tableParams = newTableParams;
        this.updateUrl(newTableParams);
        this.getData(newTableParams);
    }

    public handleColumnClicked(event: any) {
        this.redirectUser(event.data.id);
    }

}
